/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, May 31st 2022, 7:39:01 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useParams } from "react-router-dom";
import { PasswordFormInput } from "ui-widgets/forms";
import { ReusableAuthForm } from "authentication/components/ReusableAuthForm";
import { useResetPasswordCofirmationAPIForm } from "authentication/services/AuthAPI";
import { ResetPasswordConfirmationInput } from "lib/schemas";

export const ResetPasswordConfirmationForm = () => {
  const { uid, token } = useParams();
  const { useAPIFormReturn } = useResetPasswordCofirmationAPIForm({ uid, token });

  return (
    <>
      <ReusableAuthForm
        title={<>Confirm Password Reset</>}
        description={<p>Enter your new password and confirm it.</p>}
        useAPIFormReturn={useAPIFormReturn}
        showLoginLink
        showForgotPasswordLink
      >
        <PasswordFormInput<ResetPasswordConfirmationInput> label="New Password" schema_field_key="new_password1" />

        <PasswordFormInput<ResetPasswordConfirmationInput>
          label="Confirm New Password"
          schema_field_key="new_password2"
        />
      </ReusableAuthForm>
    </>
  );
};
